/**
 * «¿De qué material?» solo donde el catálogo del cliente lo distingue (armado IFC, paso «Antes de armar»).
 *
 * La pantalla manda los grupos de elementos cuyo material el modelo no dice; el servidor busca en el catálogo
 * y decide, por grupo, si hay ≥ 2 materiales distintos del MISMO elemento (entonces pregunta y ofrece
 * esos, copiados del catálogo) o no (se supone, como siempre). Los esquemas Zod del request viven en la ruta
 * (shared no depende de zod); aquí van los topes que usan los dos lados. Spec: docs/_archivo/internos/spec-material-armado.md.
 */

/** Tope de grupos por consulta. */
export const MAX_GRUPOS_MATERIAL = 30;
/** Tope de tipos (nombres de tipo IFC) por grupo. */
export const MAX_TIPOS_POR_GRUPO_MATERIAL = 8;
/** Largo máximo de un nombre de tipo / clase / etiqueta. */
export const MAX_LARGO_TIPO_MATERIAL = 160;

export interface GrupoSinMaterial {
  /** Clase IFC (la clave del grupo en la pantalla). */
  clase: string;
  /** Cómo se llama la clase para una persona («Puertas»). */
  etiqueta: string;
  /** Nombres de tipo del grupo. */
  tipos: string[];
}

export interface MaterialesPorGrupoRequest {
  grupos: GrupoSinMaterial[];
  /** El catálogo por defecto de la pantalla; se usa solo si el proyecto aún no eligió catálogos (igual que la búsqueda de conceptos). */
  catalogId?: string;
}

export interface PreguntaDeMaterial {
  clase: string;
  /** true = el catálogo distingue el material: hay que preguntar. */
  preguntar: boolean;
  /** Materiales del catálogo (texto tal cual aparece en su descripción), del más frecuente al menos. */
  opciones: string[];
  motivo: 'catalogo_distingue' | 'catalogo_no_distingue' | 'sin_candidatos';
}

export interface MaterialesPorGrupoResponse {
  grupos: PreguntaDeMaterial[];
  /** Línea de aviso si no se pudo revisar el catálogo (sin saldo, IA caída). null = todo bien. */
  avisoIa: string | null;
}

/** Aviso único cuando no se pudo revisar el catálogo (sin «IA», sin proveedor). */
export const MENSAJE_MATERIAL_NO_REVISADO =
  'No se pudo revisar tu catálogo: el material se supone con el resto del modelo y se anota en cada concepto.';
